import React from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export const CourseProgress = ({ labels = {} }) => {
  const { progress, isPro, trialExpired } = useAuth();
  const completed = progress?.completed_count || 0;
  const total = progress?.total || 51;
  const pct = Math.min(100, Math.round((completed / total) * 100));
  const remaining = Math.max(0, total - completed);

  if (isPro) return null;

  return (
    <div
      className="mb-3 rounded-2xl border border-cyan-400/20 bg-gradient-to-br from-cyan-400/[0.04] to-transparent p-4 backdrop-blur-md"
      data-testid="course-progress"
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <span className="font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-cyan-300/80">
          {labels.progress_label || "COURSE PROGRESS"}
        </span>
        {completed >= total && (
          <Trophy className="h-3.5 w-3.5 text-amber-300" />
        )}
      </div>
      <div className="text-xs font-bold text-white">
        {(labels.progress_completed || "{n}/{total}")
          .replace("{n}", completed)
          .replace("{total}", total)}
      </div>
      {/* Progress bar */}
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/5">
        <motion.div
          className="h-full bg-gradient-to-r from-cyan-400 via-purple-400 to-orange-400 shadow-[0_0_12px_rgba(0,229,255,0.5)]"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
      {/* Trial banner (when trial still active) */}
      {!trialExpired && remaining > 0 && remaining < total && (
        <p className="mt-2 text-[10px] leading-snug text-white/45">
          {(labels.trial_banner || "").replace("{remaining}", remaining)}
        </p>
      )}
    </div>
  );
};

export default CourseProgress;
